<template>
    <span></span>
</template>

<script>
import { clearAuthStorage, getStoredToken } from '@/util/auth';

export default {
  name: "TrustedDeviceMixin",
  data() {
    return {
      checkingTrustedDevice: false,
    }
  },
  methods: {
    async checkTrustedDevice() {
      const hasTrustedDevice = localStorage.getItem('trusted_device') === 'true';
      const token = getStoredToken();

      if (!token && !hasTrustedDevice) {
        return;
      }

      this.checkingTrustedDevice = true;
      try {
        if (!token) {
          clearAuthStorage();
          return;
        }

        await this.$api.get_current_user({ suppressAuthRedirect: true });
        const currentUser = this.$store.getters['user/get_current_user'];

        if (!currentUser) {
          clearAuthStorage();
          return;
        }

        if (hasTrustedDevice) {
          try {
            const response = await this.$api.user.validate_trusted_device();
            const isTrusted = response && (response.trusted === true || response.valid === true);
            if (!isTrusted) {
              localStorage.setItem('trusted_device', 'false');
            }
          } catch (error) {
            // Server validation is optional; keep the session when the token is valid.
          }
        }

        const redirect = this.$route.query.redirect || '/projects';
        await this.$router.push(redirect);
      } catch (error) {
        clearAuthStorage();
      } finally {
        this.checkingTrustedDevice = false;
      }
    },
  }
}
</script>

<style scoped>

</style>
